export const TABLE_COLUMNS = [
  // { name: 'id', align: 'center', label: 'ID', field: row => row.id, sortable: false },
  { name: 'importBy', align: 'center', label: 'Imported by', field: row => row.sys?.created_by || 'unknown', sortable: true },
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore - since typescript does not agree dates are detractable..
  { name: 'dateTime', align: 'center', label: 'Date & time', field: row => row.sys?.created_at || 'unknown', sortable: true, sort: (x, y) => new Date(x) - new Date(y), sortOrder: 'da' },
  { name: 'map', align: 'center', label: 'Map used', field: 'catalogue', sortable: true },
  { name: 'type', align: 'center', label: 'Type', field: 'type', sortable: true },
  { name: 'itemCount', align: 'center', label: 'Items', field: row => row.refs?.length, sortable: true },
  { name: 'errors', align: 'center', label: 'Items with issue', field: row => row.status?.failed?.length, sortable: true },
  { name: 'status', align: 'center', label: 'Status', field: 'status', sortable: true, sort: (x, y) => x.failed?.length ? y.active ? -1 : 1 : 0 }
]

export const PAGE_SIZE = 50
export const TABLE_PAGE_SIZE = 10
export const DATE_FORMAT = 'D MMM. HH:mm'

export default { TABLE_COLUMNS, PAGE_SIZE, DATE_FORMAT }
